<template>
  <div class="header_left">
    <div class="left_item">
      <span class="span_title">单品销售金额</span>
      <div class="left_items">
        <div class="ul_wamp">
          <ul class="ul_list">
            <li v-for="(value, index) in header" :key="index">
              {{ value.display_name }}
            </li>
          </ul>
          <ul class="ul_list">
            <li v-for="(value, index) in header" :key="index">
              {{ value.display_name }}
            </li>
          </ul>
        </div>
        <div class="ul_wamp">
          <ul class="ul_list_two" v-for="( item , index ) in dataList" :key="index">
            <li v-for="value in item" :key="value.name">
              <span>{{value.name}}</span>
              <span>{{value.value}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="left_item">
      <span class="span_title">单品数量统计</span>
      <div class="left_items">

        <div class="echarts_wamp">
          <div ref="echarts1"></div>
          <div ref="echarts2"></div>
        </div>
      </div>
    </div>
    <div class="left_item">
      <span class="span_title">面料米数统计</span>
      <div class="left_items" ref="myCharts" id="icon2"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "HaderLeft",
        data() {
            return {
                header: [],
                dataList: [],
                dataList2:[],
                data1: [],
                data2: [],
            };
        },
        mounted() {
            this.$axios.get(`${this.$url}/admin/bigpin10`).then((res) => {
                let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
                this.header = datas.cols.filter((item, index) => {
                    return index === 0 || index === 1;
                });
                let half  = Math.ceil(datas.rows.length / 2)
                datas.rows =  datas.rows.map((item) => {
                    let data = {
                        name: item[0],
                        value: Number(item[1]).toFixed(2), // 销量
                        count: Number(item[2]).toFixed(2),
                        unit: Number(item[3]).toFixed(2), // 数量
                    };
                    return data;
                })
                // let datas_copy = datas.rows
                this.dataList.push(datas.rows.slice(0 , half));
                this.dataList.push(datas.rows.slice(-half));
                datas.rows = datas.rows.sort((a , b) => Number(a.count) - Number(b.count));
                let dataName = datas.rows.map(item => item.name);
                let dataValue = datas.rows.map(item =>Number(item.count))
                let option1 = {
                    grid:{
                        left: "0",
                        right: "0",
                        bottom: "0",
                        top: "",
                        containLabel: true,

                    },
                    xAxis: {
                        type: 'value',
                        axisLine: {  //这是x轴文字颜色
                            lineStyle: {
                                color: "#fff",
                            }
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: dataName.slice(0,half),
                        axisLine: {  //这是x轴文字颜色
                            lineStyle: {
                                color: "#fff",
                            }
                        }

                    },
                    series: [{
                        data: dataValue.slice( 0 ,half),
                        type: 'bar',
                        barCategoryGap:'50%',
                        itemStyle:{
                            normal:{
                                color:'rgb(26,105,255)',
                                barBorderRadius:[10,10,10,10]
                            }
                        },
                    }],

                };
                let option2 = {
                    grid:{
                        left: "0",
                        right: "0",
                        bottom: "0",
                        top: "",
                        containLabel: true,

                    },
                    xAxis: {
                        type: 'value',
                        axisLine: {  //这是x轴文字颜色
                            lineStyle: {
                                color: "#fff",
                            }
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: dataName.slice(-half),
                        axisLine: {  //这是x轴文字颜色
                            lineStyle: {
                                color: "#fff",
                            }
                        }

                    },
                    series: [{
                        data: dataValue.slice(-half),
                        type: 'bar',
                        barCategoryGap:'50%',
                        itemStyle:{
                            normal:{
                                color:'rgb(26,105,255)',
                                barBorderRadius:[10,10,10,10]
                            }
                        },
                    }],

                };
                this.setEchart(this.$refs.echarts1 , option1);
                this.setEchart(this.$refs.echarts2 , option2);
                let dataUnit = datas.rows.map(item => item.unit)
                this.echarts(dataName, dataUnit);
            });
            this.getData();

            setInterval(() => {
                this.getData();
            }, 900000);
        },
        methods: {
            setEchart(element, option) {
                let myEcharts = this.$echarts.init(element);
                myEcharts.setOption(option);
            },
            getData() {
                this.$axios.get(`${this.$url}/admin/bigpin10`).then((res) => {
                    this.dataList = []
                    let datas = JSON.parse(res.data.split("<\/script>")[1]).data;
                    this.header = datas.cols.filter((item, index) => {
                        return index === 0 || index === 1;
                    });
                    let half  = Math.ceil(datas.rows.length / 2)
                    datas.rows =  datas.rows.map((item) => {
                        let data = {
                            name: item[0],
                            value: Number(item[1]).toFixed(2), // 销量
                            count: Number(item[2]).toFixed(2),
                            unit: Number(item[3]).toFixed(2), // 数量
                        };
                        return data;
                    })
                    // let datas_copy = datas.rows
                    this.dataList.push(datas.rows.slice(0 , half));
                    this.dataList.push(datas.rows.slice(-half));
                    datas.rows = datas.rows.sort((a , b) => Number(a.count) - Number(b.count));
                    let dataName = datas.rows.map(item => item.name);
                    let dataValue = datas.rows.map(item =>Number(item.count))
                    let option1 = {
                        grid:{
                            left: "0",
                            right: "0",
                            bottom: "0",
                            top: "",
                            containLabel: true,

                        },
                        xAxis: {
                            type: 'value',
                            axisLine: {  //这是x轴文字颜色
                                lineStyle: {
                                    color: "#fff",
                                }
                            }
                        },
                        yAxis: {
                            type: 'category',
                            data: dataName.slice(0,half),
                            axisLine: {  //这是x轴文字颜色
                                lineStyle: {
                                    color: "#fff",
                                }
                            }

                        },
                        series: [{
                            data: dataValue.slice( 0 ,half),
                            type: 'bar',
                            barCategoryGap:'50%',
                            itemStyle:{
                                normal:{
                                    color:'rgb(26,105,255)',
                                    barBorderRadius:[10,10,10,10]
                                }
                            },
                        }],

                    };
                    let option2 = {
                        grid:{
                            left: "0",
                            right: "0",
                            bottom: "0",
                            top: "",
                            containLabel: true,

                        },
                        xAxis: {
                            type: 'value',
                            axisLine: {  //这是x轴文字颜色
                                lineStyle: {
                                    color: "#fff",
                                }
                            }
                        },
                        yAxis: {
                            type: 'category',
                            data: dataName.slice(-half),
                            axisLine: {  //这是x轴文字颜色
                                lineStyle: {
                                    color: "#fff",
                                }
                            }

                        },
                        series: [{
                            data: dataValue.slice(-half),
                            type: 'bar',
                            barCategoryGap:'50%',
                            itemStyle:{
                                normal:{
                                    color:'rgb(26,105,255)',
                                    barBorderRadius:[10,10,10,10]
                                }
                            },
                        }],

                    };
                    this.setEchart(this.$refs.echarts1 , option1);
                    this.setEchart(this.$refs.echarts2 , option2);
                    let dataUnit = datas.rows.map(item => item.unit)
                    this.echarts(dataName, dataUnit);
                });
            },
            echarts(data1, data2) {
                let myEcharts = this.$echarts.init(document.getElementById("icon2"));

                let option = {
                    title: {
                        textStyle: {
                            color: "white",
                        },
                    },
                    color: "rgba(1,124,129,.5)",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    grid: {
                        left: "0",
                        right: "0",
                        bottom: "0",
                        top: "",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: data1,

                            axisTick: {
                                alignWithLabel: true,
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#fff",
                                },
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    color: "#fff",
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "生产量",
                            type: "bar",
                            barWidth: "60%",
                            data: data2,
                        },
                    ],
                };

                myEcharts.setOption(option);
            },
        },
    };
</script>

<style lang="less">
  .header_left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .left_item {
      width: 100%;
      height: 30%;
      text-align: center;
      position: relative;
      background: url("~@/assets/image/线框1.png") no-repeat;
      background-size: 100% 100%;
      .span_title {
        display: inline-block;
        color: white;
        font-size: 1.5rem;
        line-height: 0.1rem;
      }
      .ul_wamp {
        display: flex;
        justify-content: space-around;
      }
      .ul_wamp:nth-child(2){
        height: 90%;
      }
      .left_items {
        width: 95%;
        height: 70%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 999;
        overflow: hidden;
        .echarts_wamp{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-around;
          div{
            width: 50%;
            height: 100%;
          }
        }
        .ul_list {
          display: flex;
          justify-content: space-around;
          li {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: white;
            font-size: 0.75rem;
          }
        }
        .ul_list_two {
          overflow: hidden;
          width: 50%;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
          height: 100%;
          li {
            margin-top: 0.3125rem;
            display: flex;
            justify-content: space-around;
            span {
              flex: 1;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: white;
            }
          }
        }
      }
    }
  }
</style>